<div class="content scroll-gray">
  <mat-sidenav-container>
    <mat-sidenav
      #sidenav
      role="navigation"
    >
      <app-sidenav-list
        [userObject]="userObject"
        [isLoged]="dataService.getIsLoged()"
        [processActive]="processActive"
        (sidenavClose)="sidenav.close()"
      ></app-sidenav-list>
    </mat-sidenav>
    <mat-sidenav-content class="scroll-gray">
      <app-main-header
        [userObject]="userObject"
        [isLoged]="dataService.getIsLoged()"
        [idKeycloak]="idKeycloak"
        [processActive]="processActive"
        (sidenavToggle)="sidenav.toggle()"
      ></app-main-header>
      <router-outlet></router-outlet>
      <app-footer></app-footer>
      <app-whats> </app-whats>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<div class="bloked" *ngIf="isBlocked"></div>
<tour-step-template></tour-step-template>
